




























































	import UploadImage from '@/components/UploadImage.vue';
	import {
		Instance
	} from '@/classes/TayehApi';
import { CreateCustomerBody, GetInstanceResponse } from '@/classes/TayehApi/Instance';
import {Component, Inject, Vue} from 'vue-property-decorator';
	// import Sex from '../sele' @todo
	@Component({
		components: {
			'upload': UploadImage,
			datePicker: () => import('vue-persian-datetime-picker')
		}
	})
	export default class ShopCreateCustomerForm extends Vue{
		@Inject() getInstance: () => GetInstanceResponse;
		showBirthdatePicker = false;
		form = new CreateCustomerBody();
		count = 0;
		loading = false;

		
		public get birthdate() : string {
			if (!this.form.birthdate) return null;
			let date = new Date(this.form.birthdate);
			if (date)
			var mm = date.getMonth() + 1; // getMonth() is zero-based
			var dd = date.getDate();
			return [date.getFullYear(), (mm>9 ? '' : '0') + mm, (dd>9 ? '' : '0') + dd ].join('/');
		}

		
		public set birthdate(value : string) {
			this.form.birthdate = new Date(value);
		}
		
		async create() {
				this.loading = true;
				this.form.mobile = this.justify_mobile();
				try {
					const res = await Instance.createCustomer(this.getInstance().id, this.form)
					if (res.data.err) {
						this.$message({
							showClose: true,
							message: res.data.err,
							type: 'error',
							duration: 5000
						})
					} else {
						if (typeof res.data.message == 'string')
						this.$message({
							showClose: true,
							message: res.data.message,
							type: 'success',
							duration: 5000
						})
						else
						this.$message({
							showClose: true,
							message: 'مشتری با موفقیت ایجاد شد.',
							type: 'success',
							duration: 5000
						})
					}
					this.$emit('created');
				} finally {
					this.loading = false;
				}
			}
			justify_mobile() {
				let mobile = this.form.mobile;
				mobile = mobile.trim();
				mobile = mobile.replace(/۰/g, '0');
				mobile = mobile.replace(/۱/g, '1');
				mobile = mobile.replace(/۲/g, '2');
				mobile = mobile.replace(/۳/g, '3');
				mobile = mobile.replace(/۴/g, '4');
				mobile = mobile.replace(/۵/g, '5');
				mobile = mobile.replace(/۶/g, '6');
				mobile = mobile.replace(/۷/g, '7');
				mobile = mobile.replace(/۸/g, '8');
				mobile = mobile.replace(/۹/g, '9');
				mobile = mobile.replace(/\D/g, '');
				return mobile;
			}
			reset() {
				this.form.name = '';
				this.form.mobile = '';
				this.form.description = '';
			}
			handleChange(e: Event) {
				this.$emit('update')
		}
	}
